export default {
  computed: {
    /**
     *
     * @returns тим фільрів в яких є шаблони і є в state
     */
    filters_type() {
      let route = this.$route.name
      if ( route == 'purchasing' ) {
        return 'ORDERS'
      }
      if ( route == 'planning' ) {
        return 'PLANS'
      }
      if ( route == 'tenders') {
        return 'TENDERS'
      }
      return ''
    },
  },
  methods: {
    /**
     * стягнення фільтрів з стораеджа або з дефолтних шаблонів
     *
     * @param {Function} checkActualFilters  - актуалізація фільтрів на різних організаціях
     * @param {String} bar_type  - бокове меню
     */
    async updateFiltersFromStore(checkActualFilters, bar_type) {
      if  (!this.filters_type) {
        return
      }
      let filters_templates
      let update = {}
      await this.$_getFiltersFromDBStorage()
        .then(async (storage_filters) => {
          let filters = storage_filters?.filters || []
          filters_templates = await this.$store.dispatch('getFiltersTemplatesByType', this.filters_type ) || []

          this.$store.commit('setFilters', {checkActualFilters, name: this.filters_type })

          if (filters?.length) {
            filters = checkActualFilters(filters)
            update.filters = []
          }
          let template = filters.find(el => el.filterJson)

          if (template?.filters) {
            template.filters = checkActualFilters(template.filters)
          }
          if (filters?.length) {
            update.filters = this.getFilters(storage_filters?.filters).filters
            update.template_filters = storage_filters?.filters
            update.filters_mode = storage_filters.filters_mode
          } else if (filters_templates?.length && !Object.keys( storage_filters).length) {
            let default_templ = filters_templates.find(filt => filt.isDefault)
            if (default_templ) {

              let filters = JSON.parse( default_templ.filterJson )
              update.filters = filters.filters
              update.template_filters = [default_templ]
              update.filters_mode = filters.mode
            }
          }
          if (storage_filters?.search) {
            update.search = storage_filters.search
          }
          this.$root.$emit('loadData', {...update, bar: bar_type  })
          this.$root.$emit('updateFilters', {
            filters: update.template_filters || update.filters,
            filters_mode: update.filters_mode,
            not_updade: true
          })
        })
    },
    /**
     * розпарсити шаблони фільтфів - отримати масив фільтрів з шаблони
     * @param {array} templates
     * @returns
     */
    mapTemplates(templates, checkActualFilters) {
      return templates.map(filter => {
        if ( filter.filterJson && !filter.filters ) { //  !filter.filters  - якшо змінюються фільтри в шаблоні //todo як має працювати зміна шаблона?
          let parced = JSON.parse(filter.filterJson)
          return {
            ...filter,
            filters: checkActualFilters ?  checkActualFilters(parced.filters) : parced.filters,
            mode: parced.mode
          }
        } else {
          return filter
        }
      })
    },
    /**
     * з шаблонів витянути тільки фільтри
     * @param {array*} templates
     */
    getFilters(templates) {
      let filters = [],
        template
      templates.forEach(filter => {
        if ( filter.filterJson ) {
          if ( filter.filters ) {
            filters.push(...filter.filters)
          } else {
            let parced = JSON.parse(filter.filterJson)
            filters.push(...parced.filters)
          }

          template = filter
        } else {
          filters.push(filter)
        }
      })
      return {filters, template}
    },
  },
}
